import React from 'react';
import { MapPinIcon, RulerIcon, TagIcon, UsersIcon } from 'lucide-react';
const items = [{
  label: 'Family-Owned Since 2000',
  Icon: UsersIcon
}, {
  label: 'Free Estimates',
  Icon: TagIcon
}, {
  label: 'Custom Measurement & Installation',
  Icon: RulerIcon
}, {
  label: 'Three Convenient Locations',
  Icon: MapPinIcon
}];
export function TrustStrip() {
  return <section aria-label="Why customers choose Kosin’s Glass" className="border-b border-kosin-line bg-kosin-mist" data-id="element-325" data-mp="2f9o8cvigtujf">
      <ul className="mx-auto flex max-w-shell flex-wrap justify-center gap-x-6 gap-y-4 px-[18px] py-5 text-[13px] text-kosin-ink sm:px-6 sm:text-[15px] lg:flex-nowrap lg:justify-between lg:gap-x-3 lg:py-4 lg:text-[14px] xl:text-[15px]" data-id="element-326" data-mp="25d1r0gpcllm5">
        {items.map(({
        label,
        Icon
      }) => <li key={label} className="flex w-[calc(50%-12px)] items-center justify-center gap-2.5 text-center sm:w-auto sm:text-left lg:whitespace-nowrap" data-id="element-327" data-mp="3urzj9cp9ruc5">
            <Icon className="h-[18px] w-[18px] shrink-0 text-kosin-red" aria-hidden="true" data-id="element-328" data-mp="3msky8rje0gr9" />
            <span data-id="element-329" data-mp="3rrxrpv4rkm2t">{label}</span>
          </li>)}
      </ul>
    </section>;
}